import mainHeader from './components/mainHeading';
import mainFooter from './components/mainFooter';


var MainHeaderVue = new Vue({
    el: '#main-header',
    components: {
        mainHeader
    }
});

var MainFooterVue = new Vue({
    el: '#main-footer',
    components: {
        mainFooter
    }
});


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/nav.js